import React from 'react';
import PropTypes from 'prop-types';

const TermlyConsentLink = ({ title }) => (
  <span className="termly-display-preferences" role="button">
    {title}
  </span>
);

TermlyConsentLink.propTypes = {
  title: PropTypes.string.isRequired
};

export default TermlyConsentLink;
